import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Layout } from 'antd';
import { Button } from '@/base-components';
import { useThemeToken } from '@/hooks';
import {  RootState } from '../store';

interface HeaderbarPropsType {
    height?: 56;
    menuOpen?: boolean;
    // eslint-disable-next-line no-unused-vars
    onMenuOpenChange?: (open: boolean) => void;
}

const { Header } = Layout;

const Headerbar: React.FC<HeaderbarPropsType> = (props) => {
    const  {
        height = 56,
        menuOpen,
        onMenuOpenChange
    } = props;

    const curTheme = useSelector((state: RootState) => state.theme);
    const { currentSessionId } = useSelector((state: RootState) => state.chat);

    const { colorSurfaceOnCard, colorSurfaceCard } = useThemeToken();

    const colorText = useMemo(() => {
        switch (curTheme) {
            case 'light':
                return '#000';
            default:
                return '#FFF';
        }
    }, [ curTheme ]);

    const colorBg = useMemo(() => {
        switch (curTheme) {
            case 'light-blue_':
                return colorSurfaceOnCard;
            default:
                return colorSurfaceCard;
        }
    }, [ curTheme ]);

    const onDrawerChange = () => {
        onMenuOpenChange && onMenuOpenChange(!menuOpen);
    };

    return (
        <Header
            style={{
                height: height,
                padding: 16,
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: colorBg
            }}
        >
            <Button.TipButton
                hoverTip=""
                iconName={menuOpen ? 'MenuFoldOutlined' : 'MenuOutlined'}
                onClick={onDrawerChange}
                color={colorText}
            />
            {
                !menuOpen && (
                    <span style={{ color: colorText, lineHeight: 20 }}>
                        {/* 测试期间展示的SessionId，正式时去掉 */}
                        AIR (SessionId: {currentSessionId})
                    </span>
                )
            }
            <span />
        </Header>
    );
};

export default Headerbar;
